export const eventIsWithinTemporalExtent = (eventStart, eventEnd, temporalExtent) => {
  const start = temporalExtent[0].getTime()
  const end = temporalExtent[1].getTime()
  const startInExtent = eventStart > start && eventStart < end
  const endInExtent = eventEnd > start && eventEnd < end
  // keep events that starts or end within temporal extent,
  // or those that BOTH start AND end outside temporal extent
  return startInExtent || endInExtent || (eventStart < start && eventEnd > end)
}
